<template>
  <div class="container">
    <h3 class="subtitle green has-text-weight-bold">
      {{ $translate('attach') }}
    </h3>
    <div class="columns">
      <div class="column is-6">
        <div class="card">
          <div class="columns">
            <div class="column has-text-centered" :class="order.module !== 'modular' ? 'is-3' : 'is-4'">
              <b-button
                size="is-medium"
                icon-left="scanner"
                :class="[
                  missingattachment
                    ? 'is-danger'
                    : order.module === 'modular'
                    ? order.attachment.scan_fms_sx != null
                      ? 'is-uploaded'
                      : 'is-primary'
                    : order.attachment.scan_fms_sx != null &&
                      order.attachment.scan_pln_sx != null &&
                      order.attachment.scan_stl_sx != null
                    ? 'is-uploaded'
                    : order.attachment.scan_fms_sx != null ||
                      order.attachment.scan_pln_sx != null ||
                      order.attachment.scan_stl_sx != null
                    ? 'is-semiuploaded'
                    : 'is-primary',
                ]"
                inverted
                @click="isComponentModalScanSx = true"
              >
                <span>{{ $translate('duna') }}</span>
              </b-button>
            </div>
            <div class="column has-text-centered" v-if="order.module !== 'modular'">
              <b-button
                size="is-medium"
                icon-left="scanner"
                :class="[order.attachment.scan_no_duna_sx != null ? 'is-uploaded' : 'is-primary']"
                inverted
                @click="isComponentModalScanNoDUSx = true"
              >
                <span>{{ $translate('scan') }}</span>
              </b-button>
            </div>
            <div class="column has-text-centered" :class="order.module !== 'modular' ? 'is-3' : 'is-4'">
              <b-button
                size="is-medium"
                :disabled="
                  order.pair === 'right' ||
                    ((order.orderTypeVariant == 'formplusplant' || order.orderTypeVariant == 'form') &&
                      order.orderTypeSubVariant != 'file3D')
                "
                icon-left="fingerprint"
                :class="[order.attachment.grap_sx != null ? 'is-uploaded' : 'is-primary']"
                inverted
                @click="isComponentModalGrapSx = true"
              >
                <span>{{ $translate('grap') }}</span>
              </b-button>
            </div>
            <div class="column has-text-centered" :class="order.module !== 'modular' ? 'is-3' : 'is-4'">
              <b-button
                :disabled="order.pair === 'right'"
                size="is-medium"
                icon-left="paperclip"
                :class="[order.attachment.attach_sx != null ? 'is-uploaded' : 'is-primary']"
                inverted
                @click="isComponentModalAttachSx = true"
              >
                <span>{{ $translate('attach') }}</span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="card">
          <div class="columns">
            <div class="column has-text-centered" :class="order.module !== 'modular' ? 'is-3' : 'is-4'">
              <b-button
                size="is-medium"
                :disabled="
                  order.pair === 'left' ||
                    order.orderTypeVariant == 'card' ||
                    order.orderTypeVariant == 'card2' ||
                    order.orderTypeVariant == 'formplusplant' ||
                    order.orderTypeVariant == 'form'
                "
                icon-left="scanner"
                :class="[
                  missingattachment
                    ? 'is-danger'
                    : order.module === 'modular'
                    ? order.attachment.scan_fms_dx != null
                      ? 'is-uploaded'
                      : 'is-primary'
                    : order.attachment.scan_fms_dx != null &&
                      order.attachment.scan_pln_dx != null &&
                      order.attachment.scan_stl_dx != null
                    ? 'is-uploaded'
                    : order.attachment.scan_fms_dx != null ||
                      order.attachment.scan_pln_dx != null ||
                      order.attachment.scan_stl_dx != null
                    ? 'is-semiuploaded'
                    : 'is-primary',
                ]"
                inverted
                @click="isComponentModalScanDx = true"
              >
                <span>{{ $translate('duna') }}</span>
              </b-button>
            </div>
            <div class="column is-3 has-text-centered" v-if="order.module !== 'modular'">
              <b-button
                size="is-medium"
                :disabled="
                  order.pair === 'left' ||
                    order.orderTypeVariant == 'card' ||
                    order.orderTypeVariant == 'card2' ||
                    order.orderTypeVariant == 'formplusplant' ||
                    order.orderTypeVariant == 'form'
                "
                icon-left="scanner"
                :class="[order.attachment.scan_no_duna_dx != null ? 'is-uploaded' : 'is-primary']"
                inverted
                @click="isComponentModalScanNoDUDx = true"
              >
                <span>{{ $translate('scan') }}</span>
              </b-button>
            </div>

            <div class="column has-text-centered" :class="order.module !== 'modular' ? 'is-3' : 'is-4'">
              <b-button
                size="is-medium"
                :disabled="
                  order.pair === 'left' ||
                    ((order.orderTypeVariant == 'formplusplant' || order.orderTypeVariant == 'form') &&
                      order.orderTypeSubVariant != 'file3D')
                "
                icon-left="fingerprint"
                :class="[order.attachment.grap_dx != null ? 'is-uploaded' : 'is-primary']"
                inverted
                @click="isComponentModalGrapDx = true"
              >
                <span>{{ $translate('grap') }}</span>
              </b-button>
            </div>
            <div class="column has-text-centered" :class="order.module !== 'modular' ? 'is-3' : 'is-4'">
              <b-button
                :disabled="order.pair === 'left'"
                size="is-medium"
                icon-left="paperclip"
                :class="[order.attachment.attach_dx != null ? 'is-uploaded' : 'is-primary']"
                inverted
                @click="isComponentModalAttachDx = true"
              >
                <span>{{ $translate('attach') }}</span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal :active.sync="isComponentModalScanSx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('scan') }}
          </p>
        </header>
        <section class="modal-card-body">
          <div
            v-if="
              order.module === 'modular'
                ? order.attachment.scan_fms_sx != null
                : order.attachment.scan_stl_sx != null &&
                  order.attachment.scan_fms_sx != null &&
                  order.attachment.scan_pln_sx != null
            "
          >
            <b-button class="is-danger" :disabled="disabledbool" @click="removedScanSX()">
              {{ $translate('remove_scan') }}
            </b-button>
            <template v-if="order.module === 'modular' ? order.attachmentflag['scan_fms_sx'] == 1 : order.attachmentflag['scan_stl_sx'] == 1">
              <a v-if="order.module !== 'modular'" target="_blank" :href="order.attachment['scan_stl_sx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_stl') }}
                </b-button>
              </a>
              <a target="_blank" :href="order.attachment['scan_fms_sx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_fms') }}
                </b-button>
              </a>
              <a v-if="order.module !== 'modular'" target="_blank" :href="order.attachment['scan_pln_sx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_pln') }}
                </b-button>
              </a>
            </template>
          </div>

          <b-field
            v-else
            class="file"
            :type="{ 'is-danger': errors.has('scan_sx') }"
            :message="errors.first('scan_sx')"
          >
            <b-upload
              v-model="order.scans_sx"
              v-validate="order.module !== 'modular' ? 'threeneeding' : ''"
              name="scan_sx"
              multiple
              :accept="order.module === 'modular' ? '.fms' : undefined"
              drag-drop
              :disabled="disabledbool"
              @input="orderScansSX()"
            >
              <section class="section">
                <div class="content has-text-centered">
                  <p>
                    <b-icon icon="upload" size="is-large" />
                  </p>
                  <p>{{ order.module === 'modular' ? $translate('dummy_text_drop_scan_fms') : $translate('dummy_text_drop_scan') }}</p>
                </div>
              </section>
            </b-upload>
          </b-field>
          <div class="tags">
            <span v-for="(file, index) in order.scans_sx" :key="index" class="tag is-primary">
              {{ file.name }}
              <button class="delete is-small" type="button" @click="deleteScanSx(index)" />
            </span>
          </div>
          <tr
            v-for="variant in order.shoeType === 'high'
              ? $shapeTableHeadersHigh[order.module].slice(1)
              : $shapeTableHeadersLow[order.module].slice(1)"
            :key="variant"
          >
            <template v-for="x in ['center', '_sx']">
              <td :key="x" style="text-align: center; vertical-align: middle; width: 33%">
                <strong v-if="x === 'center'">{{ $translate(variant) | capitalize }}</strong>
                <b-field v-else :key="x">
                  <b-input
                    v-model="tempfootmeasurementssx[variant]"
                    type="number"
                    :disabled="true"
                    :placeholder="$translate('placeholder_numeric_mm')"
                    step="1"
                    @input="checkValue()"
                  />
                </b-field>
              </td>
            </template>
          </tr>
        </section>

        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            :disabled="order.attachment['scan_fms_sx'] == null"
            @click="isComponentModalScanSxComparison = true"
          >
            {{ $translate('comparison') | capitalize }}
          </button>
          <button class="button" type="button" @click="isComponentModalScanSx = false">
            {{ $translate('exit_without_saving') }}
          </button>
          <button
            class="button"
            type="button"
            :disabled="disabledbool"
            @click="
              importScanSxFromTemp()
              isComponentModalScanSx = false
            "
          >
            {{ $translate('exit_and_saving') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalScanSxComparison" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('comparison') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field class="file">
            <b-upload v-model="scan_fms_scan_sx" accept=".fms" @input="orderScansSXComparison()">
              <a class="button is-primary" :disabled="disabledbool">
                <b-icon icon="upload" />
                <span>{{ $translate('upload_button') }}</span>
              </a>
            </b-upload>
          </b-field>

          <tr
            v-for="variant in order.shoeType === 'high'
              ? $shapeTableHeadersHigh[order.module].slice(1)
              : $shapeTableHeadersLow[order.module].slice(1)"
            :key="variant"
          >
            <template v-for="x in ['', 'center', 'scan_sx']">
              <td :key="x" style="text-align: center; vertical-align: middle; width: 33%">
                <strong v-if="x === 'center'">{{ $translate(variant) }}</strong>
                <b-field v-else :key="x">
                  <b-input
                    v-model="tempfootmeasurementssx[variant + x]"
                    type="number"
                    :disabled="true"
                    :placeholder="$translate('placeholder_numeric_mm')"
                    step="1"
                    @input="checkValue()"
                  />
                </b-field>
              </td>
            </template>
          </tr>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalScanSxComparison = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalScanDx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('scan') }}
          </p>
        </header>
        <section class="modal-card-body">
          <div
            v-if="
              order.module === 'modular'
                ? order.attachment.scan_fms_dx != null
                : order.attachment.scan_stl_dx != null &&
                  order.attachment.scan_fms_dx != null &&
                  order.attachment.scan_pln_dx != null
            "
          >
            <b-button class="is-danger" :disabled="disabledbool" @click="removedScanDX()">
              {{ $translate('remove_scan') }}
            </b-button>
            <template v-if="order.module === 'modular' ? order.attachmentflag['scan_fms_dx'] == 1 : order.attachmentflag['scan_stl_dx'] == 1">
              <a v-if="order.module !== 'modular'" target="_blank" :href="order.attachment['scan_stl_dx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_stl') }}
                </b-button>
              </a>
              <a target="_blank" :href="order.attachment['scan_fms_dx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_fms') }}
                </b-button>
              </a>
              <a v-if="order.module !== 'modular'" target="_blank" :href="order.attachment['scan_pln_dx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_pln') }}
                </b-button>
              </a>
            </template>
          </div>

          <b-field
            v-else
            class="file"
            :type="{ 'is-danger': errors.has('scan_dx') }"
            :message="errors.first('scan_dx')"
          >
            <b-upload
              v-model="order.scans_dx"
              v-validate="order.module !== 'modular' ? 'threeneeding' : ''"
              name="scan_dx"
              multiple
              :accept="order.module === 'modular' ? '.fms' : undefined"
              drag-drop
              :disabled="disabledbool"
              @input="orderScansDX()"
            >
              <section class="section">
                <div class="content has-text-centered">
                  <p>
                    <b-icon icon="upload" size="is-large" />
                  </p>
                  <p>{{ order.module === 'modular' ? $translate('dummy_text_drop_scan_fms') : $translate('dummy_text_drop_scan') }}</p>
                </div>
              </section>
            </b-upload>
          </b-field>
          <div class="tags">
            <span v-for="(file, index) in order.scans_dx" :key="index" class="tag is-primary">
              {{ file.name }}
              <button class="delete is-small" type="button" @click="deleteScanDx(index)" />
            </span>
          </div>
          <tr
            v-for="variant in order.shoeType === 'high'
              ? $shapeTableHeadersHigh[order.module].slice(1)
              : $shapeTableHeadersLow[order.module].slice(1)"
            :key="variant"
          >
            <template v-for="x in ['center', '_dx']">
              <td :key="x" style="text-align: center; vertical-align: middle; width: 33%">
                <strong v-if="x == 'center'">{{ $translate(variant) | capitalize }}</strong>
                <b-field v-else :key="x">
                  <b-input
                    v-model="tempfootmeasurementsdx[variant]"
                    type="number"
                    :disabled="true"
                    :placeholder="$translate('placeholder_numeric_mm')"
                    step="1"
                    @input="checkValue()"
                  />
                </b-field>
              </td>
            </template>
          </tr>
        </section>

        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            :disabled="order.attachment['scan_fms_dx'] == null"
            @click="isComponentModalScanDxComparison = true"
          >
            {{ $translate('comparison') | capitalize }}
          </button>
          <button class="button" type="button" @click="isComponentModalScanDx = false">
            {{ $translate('exit_without_saving') }}
          </button>
          <button
            class="button"
            type="button"
            :disabled="disabledbool"
            @click="
              importScanDxFromTemp()
              isComponentModalScanDx = false
            "
          >
            {{ $translate('exit_and_saving') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalScanDxComparison" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('comparison') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field class="file">
            <b-upload v-model="scan_fms_scan_dx" accept=".fms" @input="orderScansDXComparison()">
              <a class="button is-primary" :disabled="disabledbool">
                <b-icon icon="upload" />
                <span>{{ $translate('upload_button') }}</span>
              </a>
            </b-upload>
          </b-field>

          <tr
            v-for="variant in order.shoeType === 'high'
              ? $shapeTableHeadersHigh[order.module].slice(1)
              : $shapeTableHeadersLow[order.module].slice(1)"
            :key="variant"
          >
            <template v-for="x in ['', 'center', 'scan_dx']">
              <td :key="x" style="text-align: center; vertical-align: middle; width: 33%">
                <strong v-if="x == 'center'">{{ $translate(variant) | capitalize }}</strong>
                <b-field v-else :key="x">
                  <b-input
                    v-model="tempfootmeasurementsdx[variant + x]"
                    type="number"
                    :disabled="true"
                    :placeholder="$translate('placeholder_numeric_mm')"
                    step="1"
                    @input="checkValue()"
                  />
                </b-field>
              </td>
            </template>
          </tr>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalScanDxComparison = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalScanNoDUSx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('scan') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('scan')">
            <b-field
              v-if="
                order.attachmentflag['scan_no_duna_sx'] === null ||
                  order.attachmentflag['scan_no_duna_sx'] === 0 ||
                  !order.attachmentflag['scan_no_duna_sx']
              "
              class="file"
              :type="{ 'is-danger': errors.has('scan_sx') }"
              :message="errors.first('scan_sx')"
            >
              <b-upload
                v-model="order.attachment['scan_no_duna_sx']"
                :disabled="disabledbool"
                :name="'scan_no_duna_sx'"
                accept=" .obj, .stl"
              >
                <a class="button is-primary" :disabled="disabledbool">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
              </b-upload>
              <span v-if="order.attachment['scan_no_duna_sx']" class="file-name">
                {{ order.attachment['scan_no_duna_sx'].name }}
              </span>
              <b-button
                :disabled="!order.attachment['scan_no_duna_sx']"
                icon-left="minus"
                class="is-danger"
                @click="removedFile('scan_no_duna_sx')"
              >
                {{ $translate('remove_file') }}
              </b-button>
            </b-field>
            <div v-else>
              <a target="_blank" :href="order.attachment['scan_no_duna_sx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file') }}
                </b-button>
              </a>
              <br />
              <b-button :disabled="disabledbool" icon-left="minus" @click="removedFile('scan_no_duna_sx')">
                {{ $translate('remove_file') }}
              </b-button>
            </div>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalScanNoDUSx = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalScanNoDUDx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('scan') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('scan')">
            <b-field
              v-if="order.attachmentflag['scan_no_duna_dx'] == null || order.attachmentflag['scan_no_duna_dx'] === 0"
              class="file"
              :type="{ 'is-danger': errors.has('scan_dx') }"
              :message="errors.first('scan_dx')"
            >
              <b-upload
                v-model="order.attachment['scan_no_duna_dx']"
                :disabled="disabledbool"
                :name="'scan_no_duna_dx'"
                accept=" .obj, .stl"
              >
                <a class="button is-primary" :disabled="disabledbool">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
              </b-upload>
              <span v-if="order.attachment['scan_no_duna_dx']" class="file-name">
                {{ order.attachment['scan_no_duna_dx'].name }}
              </span>
              <b-button
                :disabled="!order.attachment['scan_no_duna_dx']"
                icon-left="minus"
                class="is-danger"
                @click="removedFile('scan_no_duna_dx')"
              >
                {{ $translate('remove_file') }}
              </b-button>
            </b-field>
            <div v-else>
              <a target="_blank" :href="order.attachment['scan_no_duna_dx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file') }}
                </b-button>
              </a>
              <br />
              <b-button :disabled="disabledbool" icon-left="minus" @click="removedFile('scan_no_duna_dx')">
                {{ $translate('remove_file') }}
              </b-button>
            </div>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalScanNoDUDx = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalGrapSx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('grap') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('grap')">
            <b-field
              v-if="order.attachmentflag['grap_sx'] == null || order.attachmentflag['grap_sx'] == 0"
              class="file"
              :type="{ 'is-danger': errors.has('grap_sx') }"
              :message="errors.first('grap_sx')"
            >
              <b-upload
                v-model="order.attachment['grap_sx']"
                :disabled="disabledbool"
                :name="'grap_sx'"
                accept="image/*"
              >
                <a class="button is-primary" :disabled="disabledbool">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
              </b-upload>
              <span v-if="order.attachment['grap_sx']" class="file-name">
                {{ order.attachment['grap_sx'].name }}
              </span>
              <b-button
                :disabled="!order.attachment['grap_sx']"
                icon-left="minus"
                class="is-danger"
                @click="removedFile('grap_sx')"
              >
                {{ $translate('remove_file') }}
              </b-button>
            </b-field>
            <div v-else>
              <a target="_blank" :href="order.attachment['grap_sx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file') }}
                </b-button>
              </a>
              <br />
              <b-button :disabled="disabledbool" icon-left="minus" @click="removedFile('grap_sx')">
                {{ $translate('remove_file') }}
              </b-button>
            </div>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalGrapSx = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalGrapDx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('grap') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('grap')">
            <b-field
              v-if="order.attachmentflag['grap_dx'] == null || order.attachmentflag['grap_dx'] == 0"
              class="file"
              :type="{ 'is-danger': errors.has('grap_dx') }"
              :message="errors.first('grap_dx')"
            >
              <b-upload
                v-model="order.attachment['grap_dx']"
                :disabled="disabledbool"
                :name="'grap_dx'"
                accept="image/*"
              >
                <a class="button is-primary" :disabled="disabledbool">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
              </b-upload>
              <span v-if="order.attachment['grap_dx']" class="file-name">
                {{ order.attachment['grap_dx'].name }}
              </span>
              <b-button
                :disabled="!order.attachment['grap_dx']"
                icon-left="minus"
                class="is-danger"
                @click="removedFile('grap_dx')"
              >
                {{ $translate('remove_file') }}
              </b-button>
            </b-field>
            <div v-else>
              <a target="_blank" :href="order.attachment['grap_dx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file') }}
                </b-button>
              </a>
              <br />
              <b-button :disabled="disabledbool" icon-left="minus" @click="removedFile('grap_dx')">
                {{ $translate('remove_file') }}
              </b-button>
            </div>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalGrapDx = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalAttachSx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('attach') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('attach')">
            <b-field
              v-if="order.attachmentflag['attach_sx'] == null || order.attachmentflag['attach_sx'] == 0"
              class="file"
              :type="{ 'is-danger': errors.has('attach_sx') }"
              :message="errors.first('attach_sx')"
            >
              <!--<b-upload
                  v-model="order.attachment['attach_sx']"
                  :disabled="disabledbool"
                  :name="'attach_sx'"
                  accept="application/pdf,application/zip,application/rar,image/*"
                  @input="attachmentSxUpdated()"
                >-->
              <b-upload
                v-model="order.attachment['attach_sx']"
                :disabled="disabledbool"
                :name="'attach_sx'"
                @input="attachmentSxUpdated()"
              >
                <a class="button is-primary" :disabled="disabledbool">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
              </b-upload>
              <span v-if="order.attachment['attach_sx']" class="file-name">
                {{ order.attachment['attach_sx'].name }}
              </span>
              <b-button
                :disabled="!order.attachment['attach_sx']"
                icon-left="minus"
                class="is-danger"
                @click="removedFile('attach_sx')"
              >
                {{ $translate('remove_file') }}
              </b-button>
            </b-field>
            <div v-else>
              <a target="_blank" :href="order.attachment['attach_sx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file') }}
                </b-button>
              </a>
              <br />
              <b-button :disabled="disabledbool" icon-left="minus" @click="removedFile('attach_sx')">
                {{ $translate('remove_file') }}
              </b-button>
            </div>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalAttachSx = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalAttachDx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('attach') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('attach')">
            <b-field
              v-if="order.attachmentflag['attach_dx'] == null || order.attachmentflag['attach_dx'] == 0"
              class="file"
              :type="{ 'is-danger': errors.has('attach_dx') }"
              :message="errors.first('attach_dx')"
            >
              <b-upload v-model="order.attachment['attach_dx']" :disabled="disabledbool" :name="'attach_dx'">
                <a class="button is-primary" :disabled="disabledbool">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
              </b-upload>
              <span v-if="order.attachment['attach_dx']" class="file-name">
                {{ order.attachment['attach_dx'].name }}
              </span>
              <b-button
                :disabled="!order.attachment['attach_dx']"
                icon-left="minus"
                class="is-danger"
                @click="removedFile('attach_dx')"
              >
                {{ $translate('remove_file') }}
              </b-button>
            </b-field>
            <div v-else>
              <a target="_blank" :href="order.attachment['attach_dx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file') }}
                </b-button>
              </a>
              <br />
              <b-button :disabled="disabledbool" icon-left="minus" @click="removedFile('attach_dx')">
                {{ $translate('remove_file') }}
              </b-button>
            </div>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalAttachDx = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <hr class="green" />
    <h3 class="subtitle green has-text-weight-bold" @click="footMeasurementsVisible = !footMeasurementsVisible">
      {{ $translate('footmeasurements') }}
      <b-icon :icon="!footMeasurementsVisible ? 'menu-down' : 'menu-up'"> </b-icon>
    </h3>
    <b-collapse :open="footMeasurementsVisible">
      <MeasurementsTable
        ref="MeasurementsTable"
        :module="order.module"
        :disabledbool="disabledbool"
        :measures="order.footmeasurements"
        :shapes="
          order.mod.sole && order.mod.sole !== {} && order.mod.sole.shapes
            ? order.mod.sole.shapes.filter(shape => shape.type === order.shoeType)
            : []
        "
        :sizes="order.module === 'modular' ? (order.mod.sizes || {}) : (order.mod.sole && order.mod.sole !== {} ? order.mod.sole.sizes : {})"
        @update="onUpdateMeasurements"
      />
    </b-collapse>

    <p v-if="order.module === 'modular'" class="has-text-grey is-italic" style="margin-top: 0.5rem; margin-bottom: 0.5rem;">
      {{ $translate('modular_measurements_notice') }}
    </p>

    <hr class="green" />

    <h3 class="subtitle green has-text-weight-bold" @click="footAddOnVisible = !footAddOnVisible">
      {{ $translate('Add-On') }}
      <b-icon :icon="!footAddOnVisible ? 'menu-down' : 'menu-up'"> </b-icon>
    </h3>
    <b-collapse :open="footAddOnVisible">
      <MeasurementsAddOn
        :module="order.module"
        :disabledbool="disabledbool"
        :measures="order.footmeasurements"
        @update="onUpdateMeasurements"
      />
    </b-collapse>

    <hr class="green" />
    <MeasurementsTomaia
      v-if="$moduleConfiguration[this.order.module].orderHasTomaiaConfig"
      @update="onUpdateMeasurements"
      :disabledbool="disabledbool"
      :measures="order.footmeasurements"
      :shoeType="order.shoeType"
    />

    <template v-else-if="$moduleConfiguration[order.module].orderHasMeasurementsNotes">
      <hr class="green" />

      <h3 class="subtitle green">
        {{ $translate('additional_notes') | uppercase }}
      </h3>
      <b-field>
        <b-input
          v-model="order.footmeasurements.notes"
          :disabled="disabledbool"
          type="textarea"
          name="measurements_notes"
          :placeholder="$translate('placeholder_notes')"
        >
        </b-input>
      </b-field>
    </template>
  </div>
</template>

<script>
import '../../../helpers/mixins/variables/highlowmeauserements'
import '../../../helpers/mixins/variables/fondo'
import '../../../helpers/mixins/variables/plantare'
import '../../../helpers/mixins/variables/plantaremontaggio'
import '../../../helpers/mixins/variables/allacciaturames'
import '../../../helpers/mixins/variables/formames'
import '../../../helpers/mixins/variables/stylepoint'
import MeasurementsTable from './MeasurementsTable'
import MeasurementsAddOn from './MeasurementsAddOn'
import MeasurementsTomaia from './MeasurementsTomaia'

export default {
  name: 'MeasurementsFitsModular',
  components: { MeasurementsTable, MeasurementsAddOn, MeasurementsTomaia },
  props: [
    'availablemoi',
    'availablesup_plan',
    'availableriv_plan',
    'availablepel',
    'arraytodelete',
    'disabledbool',
    'missingattachment',
    'isSimplified',
    'order',
  ],
  inject: ['$validator'],
  data() {
    return {
      shapeType: null,
      shapeTablesHeaders: null,
      reali_duna_bool_sx: true,
      reali_duna_bool_dx: true,
      isComponentModalAttachSx: false,
      isComponentModalAttachDx: false,
      isComponentModalScanNoDUSx: false,
      isComponentModalScanNoDUDx: false,
      isComponentModalGrapSx: false,
      isComponentModalGrapDx: false,
      isComponentModalScanSx: false,
      isComponentModalScanSxComparison: false,
      isComponentModalScanDx: false,
      isComponentModalScanDxComparison: false,
      tempfootmeasurementssx: {},
      tempfootmeasurementsdx: {},
      images: {},
      publicPath: process.env.BASE_URL,
      scan_fms_sx: null,
      scan_fms_scan_sx: null,
      scan_fms_dx: null,
      scan_fms_scan_dx: null,
      availablemat: {},
      see1dx: false,
      see1sx: false,
      see2dx: false,
      see2sx: false,
      shoeLineSx: '',
      shoeLineDx: '',
      isHighHeelSxSet: false,
      isHighHeelDxSet: false,
      isHighHeelZepSxSet: false,
      isHighHeelZepDxSet: false,
      footMeasurementsVisible: !this.isSimplified,
      footAddOnVisible: !this.isSimplified,
    }
  },
  watch: {
    order: {
      deep: true,
      handler() {
        this.order.isDunaInsoleDisabledDx = !!this.order.isDunaInsoleDisabledDx
        this.order.isDunaInsoleDisabledSx = !!this.order.isDunaInsoleDisabledSx
      },
    },
  },
  created() {
    this.$validator.extend('nooneSelected', value => {
      if (value == 'Noone') return false
      return true
    })
    this.$validator.extend('from1to100', value => {
      if (value && value <= 100 && value >= 1) {
        return true
      }
      return false
    })
    this.$validator.extend('from15to80', value => {
      if (value <= 80 && value >= 15) {
        return true
      }
      return false
    })
    this.$validator.extend('from5to130', value => {
      if (value <= 130 && value >= 5) {
        return true
      }
      return false
    })
    this.$validator.extend('from70to500', value => {
      if (value <= 500 && value >= 70) {
        return true
      }
      return false
    })
    this.$validator.extend('threeneeding', value => {
      if (value.length == 3 || value.length == 0) {
        return true
      }
      return false
    })
    this.checkValue()

    this.isHighHeelSxSet = !!this.order.footmeasurements.high_heel_sx
    this.isHighHeelDxSet = !!this.order.footmeasurements.high_heel_dx
    this.isHighHeelZepSxSet = !!this.order.footmeasurements.high_heel_zep_sx
    this.isHighHeelZepDxSet = !!this.order.footmeasurements.high_heel_zep_dx
  },
  methods: {
    onUpdateMeasurements(newMeasurements, shapeFoot = null) {
      if (shapeFoot) {
        const [shape, foot] = shapeFoot
        this.order.mod[`shape_${foot}`] = shape ? shape.id : null
      }
      this.order.footmeasurements.left = { ...this.order.footmeasurements.left, ...newMeasurements.left }
      this.order.footmeasurements.right = { ...this.order.footmeasurements.right, ...newMeasurements.right }
    },
    /*isVariantVisible(option, side) {
      //console.log(option)
      //console.log(this.availablemat['Riv_plan'][0].variants)
      if (option.material && this.order.footmeasurements[`${option.key}_${side}`]) {
        let selectedMaterial = this.availablemat[option.material].find(
          material => material.id == this.order.footmeasurements[`${option.key}_${side}`]
        )
        if (selectedMaterial) return true
      }
      return false
    },*/
    /*getInsolePartImage(option, side) {
      //console.log(option)
      //console.log(side)
      let selectionId = this.order.footmeasurements[`${option.key}_${side}`]
      let variantId = this.order.footmeasurements[`${option.key}var_${side}`]
      if (selectionId && variantId) {
        //console.log(this.availablemat[option.material])
        let selection = this.availablemat[option.material].find(element => element.id == selectionId)
        if (selection) {
          let variant = selection.variants.find(element => element.id == variantId)
          if (variant) return variant.image
        }
      }
      return 'https://via.placeholder.com/100x100'
    },*/
    //isInsoleInfoRequired(key) {
    //  if (!this.order.isDunaInsoleDisabledSx && (key == "base_mat" || key == "plantar_type")) {
    //    return true
    //  }
    //  if (!this.order.isDunaInsoleDisabledDx && (key == "base_mat" || key == "plantar_type"))
    //  return false
    //},
    /*isInsoleInfoRequired(key, side) {
      if (!this.order.isDunaInsoleDisabledSx && (key == 'base_mat' || key == 'plantar_type') && side == 'sx') {
        return true
      }
      if (!this.order.isDunaInsoleDisabledDx && (key == 'base_mat' || key == 'plantar_type') && side == 'dx') {
        return true
      }
      if (
        !this.order.isDunaInsoleDisabledSx &&
        (key == 'base_mat' || key == 'plantar_type') &&
        side == 'sx2' &&
        this.order.secondplantsx
      ) {
        return true
      }
      if (
        !this.order.isDunaInsoleDisabledDx &&
        (key == 'base_mat' || key == 'plantar_type') &&
        side == 'dx2' &&
        this.order.secondplantdx
      ) {
        return true
      }
      return false
    },*/
    /*deleteAdditionalInsole(side) {
      if (side == 'sx') {
        this.order.secondplantsx = false
        this.order.footmeasurements.base_mat_sx2 = null
        this.order.footmeasurements.base_matvar_sx2 = null
        this.order.footmeasurements.surface_mat_sx2 = null
        this.order.footmeasurements.surface_matvar_sx2 = null
        this.order.footmeasurements.fin_dess_sx2 = null
        this.order.footmeasurements.fin_dessvar_sx2 = null
        this.order.footmeasurements.pelotte_sx2 = null
        this.order.footmeasurements.pelottevar_sx2 = null
      } else {
        this.order.secondplantdx = false
        this.order.footmeasurements.base_mat_dx2 = null
        this.order.footmeasurements.base_matvar_dx2 = null
        this.order.footmeasurements.surface_mat_dx2 = null
        this.order.footmeasurements.surface_matvar_dx2 = null
        this.order.footmeasurements.fin_dess_dx2 = null
        this.order.footmeasurements.fin_dessvar_dx2 = null
        this.order.footmeasurements.pelotte_dx2 = null
        this.order.footmeasurements.pelottevar_dx2 = null
      }
      this.$forceUpdate()
    },*/
    /*copyInsoleDetailsSxinDx() {
      this.order.footmeasurements = {
        ...this.order.footmeasurements,
        plantar_type_dx: this.order.footmeasurements.plantar_type_sx || null,
        base_mat_dx: this.order.footmeasurements.base_mat_sx || null,
        base_matvar_dx: this.order.footmeasurements.base_matvar_sx || null,
        surface_mat_dx: this.order.footmeasurements.surface_mat_sx || null,
        surface_matvar_dx: this.order.footmeasurements.surface_matvar_sx || null,
        fin_dess_dx: this.order.footmeasurements.fin_dess_sx || null,
        fin_dessvar_dx: this.order.footmeasurements.fin_dessvar_sx || null,
        fin_pelotte_dx: this.order.footmeasurements.fin_pelotte_sx || null,
        base_mat_dx2: this.order.footmeasurements.base_mat_sx2 || null,
        base_matvar_dx2: this.order.footmeasurements.base_matvar_sx2 || null,
        surface_mat_dx2: this.order.footmeasurements.surface_mat_sx2 || null,
        surface_matvar_dx2: this.order.footmeasurements.surface_matvar_sx2 || null,
        fin_dess_dx2: this.order.footmeasurements.fin_dess_sx2 || null,
        fin_dessvar_dx2: this.order.footmeasurements.fin_dessvar_sx2 || null,
        pelotte_dx2: this.order.footmeasurements.pelotte_sx2 || null,
        pelottevar_dx2: this.order.footmeasurements.pelottevar_sx2 || null,
        pelotte_dx: this.order.footmeasurements.pelotte_sx || null,
        pelottevar_dx: this.order.footmeasurements.pelottevar_sx || null,
      }
    },*/
    /*copyInsoleDetailsDxinSx() {
      this.order.footmeasurements = {
        ...this.order.footmeasurements,
        plantar_type_sx: this.order.footmeasurements.plantar_type_dx || null,
        base_mat_sx: this.order.footmeasurements.base_mat_dx || null,
        base_matvar_sx: this.order.footmeasurements.base_matvar_dx || null,
        surface_mat_sx: this.order.footmeasurements.surface_mat_dx || null,
        surface_matvar_sx: this.order.footmeasurements.surface_matvar_dx || null,
        fin_dess_sx: this.order.footmeasurements.fin_dess_dx || null,
        fin_dessvar_sx: this.order.footmeasurements.fin_dessvar_dx || null,
        fin_pelotte_sx: this.order.footmeasurements.fin_pelotte_dx || null,
        base_mat_sx2: this.order.footmeasurements.base_mat_dx2 || null,
        base_matvar_sx2: this.order.footmeasurements.base_matvar_dx2 || null,
        surface_mat_sx2: this.order.footmeasurements.surface_mat_dx2 || null,
        surface_matvar_sx2: this.order.footmeasurements.surface_matvar_dx2 || null,
        fin_dess_sx2: this.order.footmeasurements.fin_dess_dx2 || null,
        fin_dessvar_sx2: this.order.footmeasurements.fin_dessvar_dx2 || null,
        pelotte_sx2: this.order.footmeasurements.pelotte_dx2 || null,
        pelottevar_sx2: this.order.footmeasurements.pelottevar_dx2 || null,
        pelotte_sx: this.order.footmeasurements.pelotte_dx || null,
        pelottevar_sx: this.order.footmeasurements.pelottevar_dx || null,
      }
    },*/
    /*selectShoeLine(variant, side) {
      if (side == '_sx') {
        this.shoeLineSx = variant
      } else {
        this.shoeLineDx = variant
      }
    },*/
    /*resetDunaInsoleValues(side) {
      //this.order.isDunaInsoleDisabledDx=!this.reali_duna_bool_dx
      //this.order.isDunaInsoleDisabledSx=!this.reali_duna_bool_sx
      //console.log(this.order.isDunaInsoleDisabledDx)
      this.order.secondplantdx = false
      this.order.secondplantsx = false
      this.$plantare.forEach(measure => {
        this.order.footmeasurements[measure.key + side] = null
      })
      this.$forceUpdate
    },*/
    /*planRealizationChanged() {
      if (this.order.plan_realization != 'reali_duna') {
        this.order.secondplantdx = false
        this.order.secondplantsx = false
        this.order.footmeasurements['thick_cen_heel_sx'] = null
        this.order.footmeasurements['thick_pla_sx'] = null
        this.order.footmeasurements['thick_poi_sx'] = null
        this.order.footmeasurements['pla_til_heel_sx'] = null
        this.order.footmeasurements['pla_til_poi_sx'] = null
        this.order.footmeasurements['height_col_med_sx'] = null
        this.order.footmeasurements['height_col_lat_sx'] = null
        this.order.footmeasurements['thick_cen_heel_dx'] = null
        this.order.footmeasurements['thick_pla_dx'] = null
        this.order.footmeasurements['thick_poi_dx'] = null
        this.order.footmeasurements['pla_til_heel_dx'] = null
        this.order.footmeasurements['pla_til_poi_dx'] = null
        this.order.footmeasurements['height_col_med_dx'] = null
        this.order.footmeasurements['height_col_lat_dx'] = null
        this.order.footmeasurements['artificial_point_sx'] = 'n'
        this.order.footmeasurements['artificil_point_sx_optional'] = null
        this.order.footmeasurements['artificial_point_dx'] = 'n'
        this.order.footmeasurements['artificil_point_dx_optional'] = null
        this.order.footmeasurements['plantar_type_sx'] = 'Noone'
        this.order.footmeasurements['base_mat_sx'] = null
        this.order.footmeasurements['base_matvar_sx'] = null
        this.order.footmeasurements['surface_mat_sx'] = null
        this.order.footmeasurements['fin_dess_sx'] = null
        this.order.footmeasurements['pelotte_sx'] = null
        this.order.footmeasurements['base_mat_sx2'] = null
        this.order.footmeasurements['base_matvar_sx2'] = null
        this.order.footmeasurements['surface_mat_sx2'] = null
        this.order.footmeasurements['fin_dess_sx2'] = null
        this.order.footmeasurements['pelotte_sx2'] = null
        this.order.footmeasurements['plantar_type_dx'] = 'Noone'
        this.order.footmeasurements['base_mat_dx'] = null
        this.order.footmeasurements['base_matvar_dx'] = null
        this.order.footmeasurements['surface_mat_dx'] = null
        this.order.footmeasurements['fin_dess_dx'] = null
        this.order.footmeasurements['pelotte_dx'] = null
        this.order.footmeasurements['base_mat_dx2'] = null
        this.order.footmeasurements['base_matvar_dx2'] = null
        this.order.footmeasurements['surface_mat_dx2'] = null
        this.order.footmeasurements['fin_dess_dx2'] = null
        this.order.footmeasurements['pelotte_dx2'] = null
      }
      if (this.order.plan_realization != 'reali_proper') {
        this.order.footmeasurements['plant_sx'] = null
        this.order.footmeasurements['tacc_sx'] = null
        this.order.footmeasurements['plant_dx'] = null
        this.order.footmeasurements['tacc_dx'] = null
      }
      this.checkValue()
    },*/
    // changeWithoutJunction() {
    //   if (this.order.footmeasurements["without_junction"]) {
    //     this.order.footmeasurements["last_in"] = this.order.footmeasurements[
    //       "without_junction"
    //     ];
    //     this.$forceUpdate();
    //   }
    // },
    /*onMeasurementsBlur() {
      this.setShoeMeasure()
      this.isHighHeelSxSet = !!this.order.footmeasurements.high_heel_sx
      this.isHighHeelDxSet = !!this.order.footmeasurements.high_heel_dx
      this.isHighHeelZepSxSet = !!this.order.footmeasurements.high_heel_zep_sx
      this.isHighHeelZepDxSet = !!this.order.footmeasurements.high_heel_zep_dx
      if (this.isHighHeelSxSet && !this.isHighHeelZepSxSet) {
        this.order.footmeasurements.high_heel_zep_sx = this.order.footmeasurements.high_heel_sx
      }
      if (this.isHighHeelDxSet && !this.isHighHeelZepDxSet) {
        this.order.footmeasurements.high_heel_zep_dx = this.order.footmeasurements.high_heel_dx
      }
      this.checkValue()
    },*/
    checkValue() {
      // if (!this.isHighHeelSxSet && !this.order.footmeasurements.high_heel_zep_sx) {
      //   this.order.footmeasurements.high_heel_zep_sx = this.order.footmeasurements.high_heel_sx
      // }
      // if (!this.isHighHeelDxSet && !this.order.footmeasurements.high_heel_zep_dx) {
      //   this.order.footmeasurements.high_heel_zep_dx = this.order.footmeasurements.high_heel_dx
      // }
      // if (
      // this.order.footmeasurements.controllhigh_heel_sx !=
      // this.order.footmeasurements.high_heel_sx
      // ) {
      // this.order.footmeasurements.high_heel_zep_sx =
      // this.order.footmeasurements.high_heel_sx;
      // this.order.footmeasurements.controllhigh_heel_sx =
      // this.order.footmeasurements.high_heel_sx;
      // }
      // if (
      // this.order.footmeasurements.controllhigh_heel_dx !=
      // this.order.footmeasurements.high_heel_dx
      // ) {
      // this.order.footmeasurements.high_heel_zep_dx =
      // this.order.footmeasurements.high_heel_dx;
      // this.order.footmeasurements.controllhigh_heel_dx =
      // this.order.footmeasurements.high_heel_dx;
      // }

      // if (
      //   this.order.footmeasurements.controllfoot_long_sx !=
      //   this.order.footmeasurements.foot_long_sx
      // ) {
      //   this.order.footmeasurements.measure_sx =
      //     Math.round(
      //       (((this.order.footmeasurements.foot_long_sx / 10) * 3) / 2 + 1) /
      //         0.5
      //     ) * 0.5;

      //   this.order.footmeasurements.controllfoot_long_sx =
      //     this.order.footmeasurements.foot_long_sx;
      // }
      // if (
      //   this.order.footmeasurements.controllfoot_long_dx !=
      //   this.order.footmeasurements.foot_long_dx
      // ) {
      //   this.order.footmeasurements.measure_dx =
      //     Math.round(
      //       (((this.order.footmeasurements.foot_long_dx / 10) * 3) / 2 + 1) /
      //         0.5
      //     ) * 0.5;
      //   this.order.footmeasurements.controllfoot_long_dx =
      //     this.order.footmeasurements.foot_long_dx;
      // }

      // if (
      //   this.order.footmeasurements.controllf_long_formplan_sx !=
      //   this.order.footmeasurements.f_long_formplan_sx
      // ) {
      //   this.order.footmeasurements.measure_sx =
      //     Math.round(
      //       ((this.order.footmeasurements.f_long_formplan_sx / 10) * 3) /
      //         2 /
      //         0.5
      //     ) * 0.5;
      //   this.order.footmeasurements.controllf_long_formplan_sx =
      //     this.order.footmeasurements.f_long_formplan_sx;
      // }

      // if (
      //   this.order.footmeasurements.controllf_long_formplan_dx !=
      //   this.order.footmeasurements.f_long_formplan_dx
      // ) {
      //   this.order.footmeasurements.measure_dx =
      //     Math.round(
      //       ((this.order.footmeasurements.f_long_formplan_dx / 10) * 3) /
      //         2 /
      //         0.5
      //     ) * 0.5;
      //   this.order.footmeasurements.controllf_long_formplan_dx =
      //     this.order.footmeasurements.f_long_formplan_dx;
      // }

      if (this.order.attachment.scan_fms_sx != this.scan_fms_sx) {
        this.scan_fms_sx = this.order.attachment.scan_fms_sx
        if (this.scan_fms_sx != null && this.scan_fms_sx.name) {
          const reader = new FileReader()
          reader.onload = event => {
            var contents = event.target.result
            this.readFile(contents, 'sx')
          }
          reader.readAsText(this.scan_fms_sx)
        } else {
          fetch(this.scan_fms_sx)
            .then(res => res.blob())
            .then(blob => {
              const reader = new FileReader()
              reader.onload = event => {
                var contents = event.target.result
                this.readFile(contents, 'sx')
              }
              reader.readAsText(blob)
            })
        }
      }

      if (this.order.attachment.scan_fms_dx != this.scan_fms_dx) {
        this.scan_fms_dx = this.order.attachment.scan_fms_dx
        if (this.scan_fms_dx != null && this.scan_fms_dx.name) {
          const reader = new FileReader()
          reader.onload = event => {
            var contents = event.target.result
            this.readFile(contents, 'dx')
          }
          reader.readAsText(this.scan_fms_dx)
        } else {
          fetch(this.scan_fms_dx)
            .then(res => res.blob())
            .then(blob => {
              const reader = new FileReader()
              reader.onload = event => {
                var contents = event.target.result
                this.readFile(contents, 'dx')
              }
              reader.readAsText(blob)
            })
        }
      }

      for (let varian in this.order.footmeasurements) {
        if (this.order.footmeasurements[varian] == undefined) {
          delete this.order.footmeasurements[varian]
        }
      }

      if (this.order.footmeasurements['foot_long_sx'] != undefined) {
        this.order.footmeasurements['f_long_formfoot_sx'] = this.order.footmeasurements['foot_long_sx']
      }
      if (this.order.footmeasurements['foot_long_dx'] != undefined) {
        this.order.footmeasurements['f_long_formfoot_dx'] = this.order.footmeasurements['foot_long_dx']
      }

      if (this.order.footmeasurements['high_fings_sx'] != undefined) {
        this.order.footmeasurements['f_high_pointfoot_sx'] = this.order.footmeasurements['high_fings_sx']
      }
      if (this.order.footmeasurements['high_fings_dx'] != undefined) {
        this.order.footmeasurements['f_high_pointfoot_dx'] = this.order.footmeasurements['high_fings_dx']
      }

      if (this.order.footmeasurements['circ_meta_sx'] != undefined) {
        this.order.footmeasurements['f_circ_metafoot_sx'] = this.order.footmeasurements['circ_meta_sx']
      }
      if (this.order.footmeasurements['circ_meta_dx'] != undefined) {
        this.order.footmeasurements['f_circ_metafoot_dx'] = this.order.footmeasurements['circ_meta_dx']
      }

      if (this.order.footmeasurements['circ_retro_meta_sx'] != undefined) {
        this.order.footmeasurements['f_circ_retrometafoot_sx'] = this.order.footmeasurements['circ_retro_meta_sx']
      }
      if (this.order.footmeasurements['circ_retro_meta_dx'] != undefined) {
        this.order.footmeasurements['f_circ_retrometafoot_dx'] = this.order.footmeasurements['circ_retro_meta_dx']
      }

      if (this.order.footmeasurements['circ_neck_sx'] != undefined) {
        this.order.footmeasurements['f_circ_neckfoot_sx'] = this.order.footmeasurements['circ_neck_sx']
      }
      if (this.order.footmeasurements['circ_neck_dx'] != undefined) {
        this.order.footmeasurements['f_circ_neckfoot_dx'] = this.order.footmeasurements['circ_neck_dx']
      }

      if (this.order.footmeasurements['circ_ankle_sx'] != undefined) {
        this.order.footmeasurements['f_circ_mallfoot_sx'] = this.order.footmeasurements['circ_ankle_sx']
      }
      if (this.order.footmeasurements['circ_ankle_dx'] != undefined) {
        this.order.footmeasurements['f_circ_mallfoot_dx'] = this.order.footmeasurements['circ_ankle_dx']
      }

      if (this.order.footmeasurements['circ_leg_sx'] != undefined) {
        this.order.footmeasurements['f_circ_term_tomfoot_sx'] = this.order.footmeasurements['circ_leg_sx']
      }
      if (this.order.footmeasurements['circ_leg_dx'] != undefined) {
        this.order.footmeasurements['f_circ_term_tomfoot_dx'] = this.order.footmeasurements['circ_leg_dx']
      }

      if (this.order.footmeasurements['circ_past_sx'] != undefined) {
        this.order.footmeasurements['f_circ_passfoot_sx'] = this.order.footmeasurements['circ_past_sx']
      }
      if (this.order.footmeasurements['circ_past_dx'] != undefined) {
        this.order.footmeasurements['f_circ_passfoot_dx'] = this.order.footmeasurements['circ_past_dx']
      }

      if (this.order.footmeasurements['high_leg_sx'] != undefined) {
        this.order.footmeasurements['f_high_term_tomfoot_sx'] = this.order.footmeasurements['high_leg_sx']
      }
      if (this.order.footmeasurements['high_leg_dx'] != undefined) {
        this.order.footmeasurements['f_high_term_tomfoot_dx'] = this.order.footmeasurements['high_leg_dx']
      }

      // if (this.order.footmeasurements["circ_end_tom_sx"] != undefined) {
      //  this.order.footmeasurements["f_high_term_tomfoot_sx"] =
      //    this.order.footmeasurements["circ_end_tom_sx"];
      //}
      //if (this.order.footmeasurements["circ_end_tom_dx"] != undefined) {
      //  this.order.footmeasurements["f_high_term_tomfoot_dx"] =
      //    this.order.footmeasurements["circ_end_tom_dx"];
      //}

      this.$forceUpdate()
    },
    /*setCrimpHeel() {
      //altezza zeppa: hz(high_heel_zep)
      //centro tacco plantare: ctp(thick_cen_heel)
      //centro tacco suola: cts(ext_high_heel)
      //centro pianta plantare: cpp(thick_pla)
      //centro pianta suola: cps(ext_high_pla)
      //centro tacco predispozione plantare: ctpp(tacc)
      //centro pianta predispozione plantare: cppp(plant)
      //nessun plantare: crimp = hz + cts - cps
      //realizzazione duna: crimp = hz + ctp + cts - ctp - cps
      //realizzazione propria: crimp = hz + ctpp + cts - cppp - cps
      const hz_sx = parseInt(this.order.footmeasurements['high_heel_zep_sx']) || 0
      const hz_dx = parseInt(this.order.footmeasurements['high_heel_zep_dx']) || 0
      const cts_sx = parseInt(this.order.footmeasurements['ext_high_heel_sx']) || 0
      const cts_dx = parseInt(this.order.footmeasurements['ext_high_heel_dx']) || 0
      const cps_sx = parseInt(this.order.footmeasurements['ext_high_pla_sx']) || 0
      const cps_dx = parseInt(this.order.footmeasurements['ext_high_pla_dx']) || 0
      let ctp_sx = 0
      let ctp_dx = 0
      let cpp_sx = 0
      let cpp_dx = 0
      if (this.order.plan_realization == 'reali_duna') {
        ctp_sx = parseInt(this.order.footmeasurements['thick_cen_heel_sx']) || 0
        ctp_dx = parseInt(this.order.footmeasurements['thick_cen_heel_dx']) || 0
        cpp_sx = parseInt(this.order.footmeasurements['thick_pla_sx']) || 0
        cpp_dx = parseInt(this.order.footmeasurements['thick_pla_dx']) || 0
      } else if (this.order.plan_realization == 'reali_proper') {
        ctp_sx = parseInt(this.order.footmeasurements['tacc_sx']) || 0
        ctp_dx = parseInt(this.order.footmeasurements['tacc_dx']) || 0
        cpp_sx = parseInt(this.order.footmeasurements['plant_sx']) || 0
        cpp_dx = parseInt(this.order.footmeasurements['plant_dx']) || 0
      }
      this.order.footmeasurements['crimp_heel_sx'] = hz_sx + cts_sx + ctp_sx - cps_sx - cpp_sx
      this.order.footmeasurements['crimp_heel_dx'] = hz_dx + cts_dx + ctp_dx - cps_dx - cpp_dx
    },*/
    /*copyplantarepropdxinsx() {
      if (this.order.footmeasurements['plant_dx'] != undefined) {
        this.order.footmeasurements['plant_sx'] = this.order.footmeasurements['plant_dx']
      }
      if (this.order.footmeasurements['tacc_dx'] != undefined) {
        this.order.footmeasurements['tacc_sx'] = this.order.footmeasurements['tacc_dx']
      }
      this.$forceUpdate()
    },
    copyplantarepropsxindx() {
      if (this.order.footmeasurements['plant_sx'] != undefined) {
        this.order.footmeasurements['plant_dx'] = this.order.footmeasurements['plant_sx']
      }
      if (this.order.footmeasurements['tacc_sx'] != undefined) {
        this.order.footmeasurements['tacc_dx'] = this.order.footmeasurements['tacc_sx']
      }
      this.$forceUpdate()
    },

    copyplantaredxinsx() {
      for (let variant in this.$plantare) {
        if (this.order.footmeasurements[this.$plantare[variant].key + '_dx'] != undefined) {
          this.order.footmeasurements[this.$plantare[variant].key + '_sx'] = this.order.footmeasurements[
            this.$plantare[variant].key + '_dx'
          ]
        }
      }
      if (this.order.secondplantdx == undefined) {
        this.order.secondplantdx = false
      }
      this.order.secondplantsx = this.order.secondplantdx
      this.see1sx = this.see1dx
      this.see2sx = this.see2dx

      for (let variant in this.$plantaremontaggio) {
        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_dx'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_sx'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + '_dx'
          ]
        }

        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_dx'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_sx'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + 'var_dx'
          ]
        }
        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_dx2'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_sx2'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + '_dx2'
          ]
        }

        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_dx2'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_sx2'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + 'var_dx2'
          ]
        }
      }
      if (this.order.footmeasurements.artificial_point_dx != undefined) {
        this.order.footmeasurements.artificial_point_sx = this.order.footmeasurements.artificial_point_dx
      }
      if (this.order.footmeasurements.artificil_point_dx_optional != undefined) {
        this.order.footmeasurements.artificil_point_sx_optional = this.order.footmeasurements.artificil_point_dx_optional
      }
      this.setCrimpHeel()
      this.$forceUpdate()
    },
    setShoeMeasure() {
      let measurements = this.order.footmeasurements
      if (!this.order.footmeasurements.measure_sx) {
        if (measurements.controllfoot_long_sx != measurements.foot_long_sx) {
          this.order.footmeasurements.measure_sx =
            Math.round((((measurements.foot_long_sx / 10) * 3) / 2 + 1) / 0.5) * 0.5
          this.order.footmeasurements.controllfoot_long_sx = measurements.foot_long_sx
        }
        if (measurements.controllf_long_formplan_sx != measurements.f_long_formplan_sx) {
          this.order.footmeasurements.measure_sx =
            Math.round(((measurements.f_long_formplan_sx / 10) * 3) / 2 / 0.5) * 0.5
          this.order.footmeasurements.controllf_long_formplan_sx = measurements.f_long_formplan_sx
        }
      }
      if (!this.order.footmeasurements.measure_dx) {
        if (measurements.controllfoot_long_dx != measurements.foot_long_dx) {
          this.order.footmeasurements.measure_dx =
            Math.round((((measurements.foot_long_dx / 10) * 3) / 2 + 1) / 0.5) * 0.5
          this.order.footmeasurements.controllfoot_long_dx = measurements.foot_long_dx
        }
        if (measurements.controllf_long_formplan_dx != measurements.f_long_formplan_dx) {
          this.order.footmeasurements.measure_dx =
            Math.round(((measurements.f_long_formplan_dx / 10) * 3) / 2 / 0.5) * 0.5
          this.order.footmeasurements.controllf_long_formplan_dx = measurements.f_long_formplan_dx
        }
      }
    },
    copyplantaresxindx() {
      for (let variant in this.$plantare) {
        if (this.order.footmeasurements[this.$plantare[variant].key + '_sx'] != undefined) {
          this.order.footmeasurements[this.$plantare[variant].key + '_dx'] = this.order.footmeasurements[
            this.$plantare[variant].key + '_sx'
          ]
        }
      }
      if (this.order.secondplantsx == undefined) {
        this.order.secondplantsx = false
      }
      this.order.secondplantdx = this.order.secondplantsx
      this.see1dx = this.see1sx
      this.see2dx = this.see2sx

      for (let variant in this.$plantaremontaggio) {
        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_sx'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_dx'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + '_sx'
          ]
        }

        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_sx'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_dx'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + 'var_sx'
          ]
        }

        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_sx2'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_dx2'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + '_sx2'
          ]
        }
        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_sx2'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_dx2'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + 'var_sx2'
          ]
        }
      }
      if (this.order.footmeasurements.artificial_point_sx != undefined) {
        this.order.footmeasurements.artificial_point_dx = this.order.footmeasurements.artificial_point_sx
      }
      if (this.order.footmeasurements.artificil_point_sx_optional != undefined) {
        this.order.footmeasurements.artificil_point_dx_optional = this.order.footmeasurements.artificil_point_sx_optional
      }
      this.setCrimpHeel()
      this.$forceUpdate()
    },
    copyallfondxinsx() {
      for (let variant in this.$allacciaturames) {
        if (this.order.footmeasurements[this.$allacciaturames[variant].key + '_dx'] != undefined) {
          this.order.footmeasurements[this.$allacciaturames[variant].key + '_sx'] = this.order.footmeasurements[
            this.$allacciaturames[variant].key + '_dx'
          ]
        }
      }
      for (let variant in this.$fondo) {
        if (this.order.footmeasurements[this.$fondo[variant].key + '_dx'] != undefined) {
          this.order.footmeasurements[this.$fondo[variant].key + '_sx'] = this.order.footmeasurements[
            this.$fondo[variant].key + '_dx'
          ]
        }
      }

      this.order.footmeasurements.measure_sx == !!this.order.footmeasurements.measure_dx
        ? this.order.footmeasurements.measure_dx
        : null
      this.order.footmeasurements.crimp_heel_sx == !!this.order.footmeasurements.crimp_heel_dx
        ? this.order.footmeasurements.crimp_heel_dx
        : null
      this.$forceUpdate()
    },
    copyallfonsxindx() {
      for (let variant in this.$allacciaturames) {
        if (this.order.footmeasurements[this.$allacciaturames[variant].key + '_sx'] != undefined) {
          this.order.footmeasurements[this.$allacciaturames[variant].key + '_dx'] = this.order.footmeasurements[
            this.$allacciaturames[variant].key + '_sx'
          ]
        }
      }
      for (let variant in this.$fondo) {
        if (this.order.footmeasurements[this.$fondo[variant].key + '_sx'] != undefined) {
          this.order.footmeasurements[this.$fondo[variant].key + '_dx'] = this.order.footmeasurements[
            this.$fondo[variant].key + '_sx'
          ]
        }
      }
      this.order.footmeasurements.measure_dx == !!this.order.footmeasurements.measure_sx
        ? this.order.footmeasurements.measure_sx
        : null
      this.order.footmeasurements.crimp_heel_dx == !!this.order.footmeasurements.crimp_heel_sx
        ? this.order.footmeasurements.crimp_heel_sx
        : null
      this.$forceUpdate()
    },
    copyhighlowdxinsx() {
      let temp = []
      temp = this.$highlowmeasu
      for (let variant in temp) {
        if (this.order.footmeasurements[temp[variant].key + '_dx'] != undefined) {
          this.order.footmeasurements[temp[variant].key + '_sx'] = this.order.footmeasurements[
            temp[variant].key + '_dx'
          ]
        }
      }
      for (let variant in this.$formames) {
        if (this.order.footmeasurements[this.$formames[variant].key + 'foot_dx'] != undefined) {
          this.order.footmeasurements[this.$formames[variant].key + 'foot_sx'] = this.order.footmeasurements[
            this.$formames[variant].key + 'foot_dx'
          ]
        }

        if (this.order.footmeasurements[this.$formames[variant].key + 'plan_dx'] != undefined) {
          this.order.footmeasurements[this.$formames[variant].key + 'plan_sx'] = this.order.footmeasurements[
            this.$formames[variant].key + 'plan_dx'
          ]
        }
      }
      this.checkValue()
      this.$forceUpdate()
    },
    copyhighlowsxindx() {
      let temp = []
      temp = this.$highlowmeasu
      for (let variant in temp) {
        if (this.order.footmeasurements[temp[variant].key + '_sx'] != undefined) {
          this.order.footmeasurements[temp[variant].key + '_dx'] = this.order.footmeasurements[
            temp[variant].key + '_sx'
          ]
        }
      }
      for (let variant in this.$formames) {
        if (this.order.footmeasurements[this.$formames[variant].key + 'foot_sx'] != undefined) {
          this.order.footmeasurements[this.$formames[variant].key + 'foot_dx'] = this.order.footmeasurements[
            this.$formames[variant].key + 'foot_sx'
          ]
        }

        if (this.order.footmeasurements[this.$formames[variant].key + 'plan_sx'] != undefined) {
          this.order.footmeasurements[this.$formames[variant].key + 'plan_dx'] = this.order.footmeasurements[
            this.$formames[variant].key + 'plan_sx'
          ]
        }
      }
      this.checkValue()
      this.$forceUpdate()
    },*/
    orderScansSX() {
      var stl = 0
      var fms = 0
      var pln = 0
      this.order.scans_sx.forEach((ord, index) => {
        if (ord.name.endsWith('.stl') || ord.name.endsWith('.fms') || ord.name.endsWith('.pln')) {
          if (ord.name.endsWith('.stl')) {
            stl++
            if (stl > 1) {
              this.order.scans_sx.splice(index, 1)
            }
          }
          if (ord.name.endsWith('.fms')) {
            fms++
            if (fms > 1) {
              this.order.scans_sx.splice(index, 1)
            }
          }
          if (ord.name.endsWith('.pln')) {
            pln++
            if (pln > 1) {
              this.order.scans_sx.splice(index, 1)
            }
          }
        } else {
          this.order.scans_sx.splice(index, 1)
        }
      })
      this.order.scans_sx.forEach(ord => {
        if (ord.name.endsWith('.stl')) {
          this.order.attachment.scan_stl_sx = ord
        }
        if (ord.name.endsWith('.fms')) {
          this.order.attachment.scan_fms_sx = ord
        }
        if (ord.name.endsWith('.pln')) {
          this.order.attachment.scan_pln_sx = ord
        }
      })
      this.checkValue()
    },
    orderScansSXComparison() {
      const reader = new FileReader()
      reader.onload = event => {
        var contents = event.target.result
        this.readFileComparison(contents, 'sx')
      }
      reader.readAsText(this.scan_fms_scan_sx)
    },
    orderScansDXComparison() {
      const reader = new FileReader()
      reader.onload = event => {
        var contents = event.target.result
        this.readFileComparison(contents, 'dx')
      }
      reader.readAsText(this.scan_fms_scan_dx)
    },
    orderScansDX() {
      var stl = 0
      var fms = 0
      var pln = 0
      this.order.scans_dx.forEach((ord, index) => {
        if (ord.name.endsWith('.stl') || ord.name.endsWith('.fms') || ord.name.endsWith('.pln')) {
          if (ord.name.endsWith('.stl')) {
            stl++
            if (stl > 1) {
              this.order.scans_dx.splice(index, 1)
            }
          }
          if (ord.name.endsWith('.fms')) {
            fms++
            if (fms > 1) {
              this.order.scans_dx.splice(index, 1)
            }
          }
          if (ord.name.endsWith('.pln')) {
            pln++
            if (pln > 1) {
              this.order.scans_dx.splice(index, 1)
            }
          }
        } else {
          this.order.scans_dx.splice(index, 1)
        }
      })
      this.order.scans_dx.forEach(ord => {
        if (ord.name.endsWith('.stl')) {
          this.order.attachment.scan_stl_dx = ord
        }
        if (ord.name.endsWith('.fms')) {
          this.order.attachment.scan_fms_dx = ord
        }
        if (ord.name.endsWith('.pln')) {
          this.order.attachment.scan_pln_dx = ord
        }
      })
      this.checkValue()
    },
    attachmentSxUpdated() {
      //console.log('diocane')
      //console.log(this.order.attachment.attach_sx)
    },
    removedScanSX() {
      this.arraytodelete.scan_stl_sx = this.order.attachment.scan_stl_sx
      this.order.attachment.scan_stl_sx = null
      this.order.attachmentflag.scan_stl_sx = 0

      this.arraytodelete.scan_fms_sx = this.order.attachment.scan_fms_sx
      this.order.attachment.scan_fms_sx = null
      this.order.attachmentflag.scan_fms_sx = 0

      this.arraytodelete.scan_pln_sx = this.order.attachment.scan_pln_sx
      this.order.attachment.scan_pln_sx = null
      this.order.attachmentflag.scan_pln_sx = 0
      this.order.scans_sx = []
    },
    removedScanDX() {
      this.arraytodelete.scan_stl_dx = this.order.attachment.scan_stl_dx
      this.order.attachment.scan_stl_dx = null
      this.order.attachmentflag.scan_stl_dx = 0

      this.arraytodelete.scan_fms_dx = this.order.attachment.scan_fms_dx
      this.order.attachment.scan_fms_dx = null
      this.order.attachmentflag.scan_fms_dx = 0

      this.arraytodelete.scan_pln_dx = this.order.attachment.scan_pln_dx
      this.order.attachment.scan_pln_dx = null
      this.order.attachmentflag.scan_pln_dx = 0
      this.order.scans_dx = []
    },
    deleteScanSx(index) {
      if (this.order.scans_sx[index].name.endsWith('.stl')) {
        this.order.attachment.scan_stl_sx = null
      }
      if (this.order.scans_sx[index].name.endsWith('.fms')) {
        this.order.attachment.scan_fms_sx = null
        this.RemoveSxtemp()
      }
      if (this.order.scans_sx[index].name.endsWith('.pln')) {
        this.order.attachment.scan_pln_sx = null
      }

      this.order.scans_sx.splice(index, 1)
    },
    deleteScanDx(index) {
      if (this.order.scans_dx[index].name.endsWith('.stl')) {
        this.order.attachment.scan_stl_dx = null
      }
      if (this.order.scans_dx[index].name.endsWith('.fms')) {
        this.order.attachment.scan_fms_dx = null
        this.RemoveDxtemp()
      }
      if (this.order.scans_dx[index].name.endsWith('.pln')) {
        this.order.attachment.scan_pln_dx = null
      }

      this.order.scans_dx.splice(index, 1)
    },
    RemoveSxtemp() {
      this.tempfootmeasurementssx = {}
    },
    RemoveDxtemp() {
      this.tempfootmeasurementsdx = {}
    },
    removedFile(item) {
      this.arraytodelete[item] = this.order.attachment[item]
      this.order.attachment[item] = null
      this.order.attachmentflag[item] = 0
    },
    readFileComparison(content, side) {
      //console.log('content', content)
      const EOL = '\n'
      var stringToFind = 'Fl='
      var pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.lengthscan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.lengthscan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_Ball='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.ballscan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.ballscan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      /* stringToFind = 'Pl_BehindBall='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_retro_metascan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_retro_metascan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }*/

      // stringToFind = "Pl_Ball=";
      // pos = content.indexOf(stringToFind);
      // model.metatatarsusGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      stringToFind = 'Pl_Heel='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.heelscan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.heelscan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      // stringToFind = "Pl_Heel=";
      // pos = content.indexOf(stringToFind);
      // model.heelGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      // stringToFind = 'Pl_Ankle='
      // pos = content.indexOf(stringToFind)
      // if (side == 'sx') {
      //   this.tempfootmeasurementssx.circ_anklescan_sx = Math.ceil(
      //     content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
      //   ).toString()
      // } else {
      //   this.tempfootmeasurementsdx.circ_anklescan_dx = Math.ceil(
      //     content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
      //   ).toString()
      // }

      // stringToFind = 'Pl_AnkleHeight='
      // pos = content.indexOf(stringToFind)
      // if (side == 'sx') {
      //   this.tempfootmeasurementssx.high_anklescan_sx = Math.ceil(
      //     content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
      //   ).toString()
      // } else {
      //   this.tempfootmeasurementsdx.high_anklescan_dx = Math.ceil(
      //     content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
      //   ).toString()
      // }

      // stringToFind = "Pl_Ankle=";
      // pos = content.indexOf(stringToFind);
      // model.ankleGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      stringToFind = 'Pl_Instep='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.instepscan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
        this.tempfootmeasurementssx.instep_italyscan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.instepscan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
        this.tempfootmeasurementsdx.instep_italyscan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_UpperEnd='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.end_tomaiascan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.end_tomaiascan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }
      //
      // stringToFind = 'Pl_UpperEndHeight='
      // pos = content.indexOf(stringToFind)
      // if (side == 'sx') {
      //   this.tempfootmeasurementssx.high_legscan_sx = Math.ceil(
      //     content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
      //   ).toString()
      // } else {
      //   this.tempfootmeasurementsdx.high_legscan_dx = Math.ceil(
      //     content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
      //   ).toString()
      // }
      //
      // stringToFind = 'Pl_HeelHeight='
      // pos = content.indexOf(stringToFind)
      // if (side == 'sx') {
      //   this.tempfootmeasurementssx.high_heelscan_sx = Math.ceil(
      //     content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
      //   ).toString()
      // } else {
      //   this.tempfootmeasurementsdx.high_heelscan_dx = Math.ceil(
      //     content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
      //   ).toString()
      // }

      // stringToFind = "Pl_Instep=";
      // pos = content.indexOf(stringToFind);
      // model.instepGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      this.$forceUpdate()
    },
    readFile(content, side) {
      // console.log(content)
      const EOL = '\n'
      var stringToFind = 'Fl='
      var pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.length = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.length = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_Ball='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.ball = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.ball = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      /*stringToFind = 'Pl_BehindBall='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_retro_meta_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_retro_meta_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }*/

      // stringToFind = "Pl_Ball=";
      // pos = content.indexOf(stringToFind);
      // model.metatatarsusGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      stringToFind = 'Pl_Heel='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.heel = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.heel = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Fw='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.width = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.width = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Bth='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.toe_height = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.toe_height = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      // stringToFind = "Pl_Heel=";
      // pos = content.indexOf(stringToFind);
      // model.heelGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      /*stringToFind = 'Pl_Ankle='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_ankle_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_ankle_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_AnkleHeight='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.high_ankle_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.high_ankle_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }*/

      // stringToFind = "Pl_Ankle=";
      // pos = content.indexOf(stringToFind);
      // model.ankleGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      stringToFind = 'Pl_Instep='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.instep = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
        this.tempfootmeasurementssx.instep_italy = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.instep = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
        this.tempfootmeasurementsdx.instep_italy = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_UpperEnd='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.end_tomaia = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.end_tomaia = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      /*

      stringToFind = 'Pl_UpperEndHeight='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.high_leg_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.high_leg_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_HeelHeight='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.high_heel_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.high_heel_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }*/

      // stringToFind = "Pl_Instep=";
      // pos = content.indexOf(stringToFind);
      // model.instepGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      this.$forceUpdate()
    },
    importScanSxFromTemp() {
      const updatedLeft = { ...(this.order.footmeasurements.left || {}) }
      this.$shapeTableHeadersHigh[this.order.module].forEach(header => {
        if (this.tempfootmeasurementssx[header] !== undefined) {
          updatedLeft[header] = this.tempfootmeasurementssx[header]
        }
      })

      this.order.footmeasurements = {
        ...(this.order.footmeasurements || {}),
        left: updatedLeft,
        right: { ...(this.order.footmeasurements.right || {}) },
      }
      this.checkValue()
    },

    importScanDxFromTemp() {
      const updatedRight = { ...(this.order.footmeasurements.right || {}) }
      this.$shapeTableHeadersHigh[this.order.module].forEach(header => {
        if (this.tempfootmeasurementsdx[header] !== undefined) {
          updatedRight[header] = this.tempfootmeasurementsdx[header]
        }
      })

      this.order.footmeasurements = {
        ...(this.order.footmeasurements || {}),
        right: updatedRight,
        left: { ...(this.order.footmeasurements.left || {}) },
      }

      this.checkValue()
    },
  },
}
</script>
<style scoped>
.container >>> td input {
  text-align: center;
}

.container >>> .is-semiuploaded {
  background-color: #ffdd57;
  color: black;
}
.container >>> .is-uploaded {
  background-color: #008a6b;
  color: white;
}

.insoleImage {
  float: right;
  width: 100px;
  height: 100px;
}
</style>
